module.exports = __webpack_public_path__ + "img/gcash-logo.6e1ae031.png";